import Flickity from 'flickity'
import 'flickity/css/flickity.css'


export default {

    bind: function(el, binding, vnode) {

        vnode.context.$nextTick(function() {
            var flkty = new Flickity( el, {
                        cellAlign: 'left',
                        freeScroll: true,
                        contain: true,
                        prevNextButtons: false,
                        pageDots: false
            });
        })

    },
}